/*
 * Module for the DirectDeposit/_PaymentHistory view
*/
rs.module("ui/content/benefits/directdeposit/directdeposits",

    [ ],

    function () {

        // Initialize the module
        function initialize(listApi, backendUrls) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {
                $.get(
                    backendUrls.getDirectDepositDetail,
                    {
                        directDepositKey: context.DirectDepositKey,
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);